<template>
  <div class="helper-container helper-container--top">
    <div class="line" style="position: relative">
      <!-- <svg-icon v-if="showIcon" icon="hp-search" class="line__search icon-lg" /> -->
      <input
        :placeholder="searchPlaceholder"
        type="text"
        v-model="searchInput"
        :disabled="disabled"
        @input="emit('search')"
        @focus.stop="emit('search')"
        @keydown.tab="(event) => emit('handleTab', event)"
        autocomplete="nope"
        class="form-control-sm w-100"
        :class="{ 'no-right-border-radius': button, 'is-disabled': disabled }"
      />
      <slot />
    </div>
    <template v-if="hasExcludeMode">
      <button class="btn exclude-switcher" :class="{ 'is-active': exclude }" @click="emit('excludeSwitch')">
        {{ $t('excludeMode') }}:
        <span>{{ exclude ? 'ON' : 'OFF' }}</span>
      </button>
    </template>
  </div>
</template>

<script setup>
defineProps({
  searchPlaceholder: {
    type: String,
    default: 'Search...',
  },
  hasExcludeMode: {
    type: Boolean,
    default: false,
  },
  exclude: {
    type: Boolean,
    default: false,
  },
  button: {
    type: Boolean,
    default: false,
  },
  // showIcon: {
  //   type: Boolean,
  //   default: false
  // },
  isMulti: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['search', 'excludeSwitch', 'toggleCheckboxes', 'handleTab']);

const searchInput = defineModel({
  type: String,
  default: '',
});
</script>

<style scoped lang="scss"></style>
